
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import candidatesActions from "../../redux/candidates/actions";
import commonActions from "../../redux/common/actions";
import CommonOtpVerification from "./otpVerificationWrapper";
import Cookies from "js-cookie";
import authActions from "../../redux/auth/actions";
import keycloakService from "../../modules";
import ApparMandatoryModal from "../modals/apparMandatory"
import RedirectToHomeEditModal from "../modals/redirectToHomeEditModal";
const RegistrationClosed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const statusdata = useSelector((state) => state.candidatesReducer.bypassRegistrationData);
  const MobileVerifiedDetails = useSelector((state) => state.authReducer.MobileVerifiedDetails);
  const {mobileVerifiedLoaded} = useSelector((state) => state.authReducer);
  const apparMandatoryDialog = useSelector((state) => state.authReducer.apparMandatoryDialog)
  const ProfileSummaryDetails = useSelector(
    (state) => state.authReducer.ProfileSummaryDetails
  );
  const [hasHandledVerification, setHasHandledVerification] = useState(false);
  const [candidateNotFound, setCandidateNotFound] = useState(false)
      const { showRedirectToHomeModal } = useSelector(state => state.commonReducer);
  


  const searchParams = new URLSearchParams(location.search);
  const courseid = searchParams.get("courseid");
  // const coursename = decodeURIComponent(searchParams.get("coursename") || "");
  // const coursename=location.state.coursename;
  const fromInternal = location.state?.forceIf || false;
  const message = searchParams.get("message");
  const [isOtpPopupOpen, setIsOtpPopupOpen] = useState(false);
  const token = Cookies.set("mhet_cnd_token", keycloakService.getToken())

  const queryString = window.location.search;
  let coursename;
  const match = queryString.match(/coursename=(.*)/);
  if (match && match[1]) {
    coursename = decodeURIComponent(match[1]);

  }
  if (courseid && coursename) {
    sessionStorage.setItem("courseid", courseid);
    sessionStorage.setItem("coursename", coursename);
  }

  // Output: MAH-PGP-CET/PGO-CET/M.Sc(A&SLP)-CET/M.Sc(P&O)-CET-2025

  //   const candidateid = useSelector((state)=>state.authReducer.candidateTokenDetails?.candidateid)
  // useEffect(() => {
  //     if (candidateid) dispatch({ type: candidatesActions.GET_ALL_COURSE_LIST });
  //   }, [candidateid]);

  // useEffect(() => {
  //       sessionStorage.setItem("coursename", coursename);
  // },[])



  useEffect(() => {
    dispatch({ type: authActions.GET_MOBILE_VERIFIED, payload: { navigate } });
  }, [courseid]);

  // useEffect(() => {
  //   if (courseid && coursename) {
  //     dispatch({
  //       type: candidatesActions.GET_BYPASS_REGISTRATION,
  //       payload: {
  //         navigate,
  //         courseid,
  //         coursename,
  //         callback: () => {
  //           dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  //         },
  //       },
  //     });
  //   }

  // }, [courseid, coursename]);


  useEffect(() => {

    if(mobileVerifiedLoaded){
      if (MobileVerifiedDetails?.mobilenoverified === undefined) {
    return;
  }


    Cookies.set("mhet_cnd_project", "mhcet");
    if (courseid && coursename) {
  const isVerified =
    Number(MobileVerifiedDetails?.mobilenoverified) === 1 ||
    MobileVerifiedDetails?.mobilenoverified === true;


  if (isVerified || fromInternal) {
        dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
        dispatch({
          type: candidatesActions.SET_STATUS,
          payload: true
        });
        sessionStorage.setItem("status", true);
        dispatch({
          type: candidatesActions.GET_BYPASS_REGISTRATION,
          payload: {
            navigate,
            courseid,
            coursename,
            callback: () => {
              dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
            },
          },
        });
      } else if(MobileVerifiedDetails?.mobilenoverified === false) {
        dispatch({
          type: candidatesActions.SET_STATUS,
          payload: false
        });
        sessionStorage.setItem("status", false);
        dispatch({
          type: authActions.SEND_OTP_FOR_MOBILE_VERIFICATION,
          payload: {
            data: {
              mobileno: MobileVerifiedDetails?.mobileno || ProfileSummaryDetails[0]?.mobileno,
              navigate
            },
          },
        });
        setIsOtpPopupOpen(true);
      }
    }
  }
  }, [
  MobileVerifiedDetails?.mobilenoverified,
  fromInternal,
  ]);



  if (apparMandatoryDialog) {
    return <ApparMandatoryModal open={true} />
  }

    if (showRedirectToHomeModal) {
      // alert("dummy")
    return <RedirectToHomeEditModal open={showRedirectToHomeModal} />
  }


  return (
    <>{statusdata !== "Register Now" && (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "80vh", minWidth: "100vh" }}>
        <h1 style={{ color: "black" }}>
          {statusdata
            ? statusdata
            : "Something went wrong..."}
        </h1>
      </div>)}


      {isOtpPopupOpen && (<CommonOtpVerification
        open={isOtpPopupOpen}
        setOpen={setIsOtpPopupOpen}
        mobileNumber={MobileVerifiedDetails?.mobileno}
        onSuccess={() => {
          dispatch({
            type: candidatesActions.GET_BYPASS_REGISTRATION,
            payload: {
              navigate,
              courseid,
              coursename,
              callback: () => {
                dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
              },
            },
          });
        }}
      />)}


    </>
  );
};

export default RegistrationClosed;
